export default {
    zoho_estimate_id: "Zoho Estimate Number",
    zoho_estimate_number_short: "Zoho Estimate #",
    zoho_total: "Zoho Total",
    zoho_status: "Zoho Status",
    edit_zoho_quote: "Edit Zoho Quote",
};
